import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="116 107 24 24" {...props}>
    <path
      d="M130.531,122.563h-11.808c-0.544,0-0.985-0.441-0.985-0.984c0-0.545,0.441-0.986,0.985-0.986h11.808
      c0.545,0,0.986,0.441,0.986,0.986C131.518,122.121,131.076,122.563,130.531,122.563z M137.275,117.556h-11.807
      c-0.545,0-0.985-0.441-0.985-0.985c0-0.545,0.44-0.986,0.985-0.986h11.807c0.545,0,0.986,0.441,0.986,0.986
      C138.262,117.115,137.82,117.556,137.275,117.556z M134.836,112.815c0,0.544-0.441,0.985-0.986,0.985s-0.986-0.441-0.986-0.985
      c0-0.545,0.441-0.986,0.986-0.986S134.836,112.27,134.836,112.815z M123.135,125.334c0,0.545-0.441,0.986-0.985,0.986
      c-0.544,0-0.986-0.441-0.986-0.986c0-0.543,0.441-0.984,0.986-0.984C122.694,124.35,123.135,124.791,123.135,125.334z"
    />
    <path
      d="M127.995,128.588c-0.962,0-1.911-0.143-2.822-0.426c-0.52-0.162-0.811-0.713-0.65-1.232
      c0.162-0.521,0.714-0.813,1.233-0.65c0.722,0.225,1.475,0.338,2.239,0.338c3.343,0,6.244-2.145,7.222-5.34
      c0.076-0.248,0.248-0.459,0.48-0.58c0.229-0.123,0.5-0.148,0.75-0.072c0.52,0.158,0.813,0.709,0.652,1.23
      C135.867,125.881,132.209,128.588,127.995,128.588z M119.831,117.549c-0.312,0-0.606-0.148-0.792-0.399s-0.241-0.576-0.15-0.874
      c1.233-4.027,4.892-6.731,9.106-6.731c0.962,0,1.912,0.144,2.822,0.426c0.25,0.077,0.457,0.251,0.58,0.481
      c0.121,0.231,0.146,0.502,0.07,0.751c-0.078,0.25-0.252,0.459-0.482,0.58c-0.23,0.122-0.502,0.146-0.752,0.069
      c-0.721-0.222-1.475-0.335-2.238-0.335c-3.342,0-6.245,2.145-7.222,5.339c-0.126,0.414-0.509,0.696-0.941,0.697L119.831,117.549z"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/Segment.jsx